// extracted by mini-css-extract-plugin
module.exports = {"main_container":"ConfirmationModalControl_main_container__10QfL"};